import React, { useEffect, useState, useContext } from 'react';
// material
import Grid from '@material-ui/core/Grid';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'; // DatePicker
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import Hidden from '@material-ui/core/Hidden';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
// moment
import DateFnsUtils from '@date-io/moment';
import moment from 'moment';
// lodash
import { uniqueId } from 'lodash';
// image
import { Img } from 'react-image';
// i18next
import { useTranslation } from 'react-i18next';
// component
// import { element } from 'prop-types';
import ModeContext from '../../../context/ModeContext';
import { styles } from '../style';
import { globalStyle } from '../../../global/style';
import { FlexButton, StyledViewButton } from '../../../components/button/Button';
import Modal from '../../../components/modal/Modal';
import { RainIcon } from '../../../assets/svg/Icon';

export default function ImageRainfallisohyet() {
  const [currentDate, setCurrentDate] = useState();
  const [maxDateTime, setMaxDateTime] = useState();
  const [isLoading, setLoading] = useState(false);
  const [hasError, sethasError] = useState();
  const [hasLatest, setLatest] = useState();
  const [hasHistory, setHistory] = useState();
  const [hasHistoryMonthly, setHistoryMonthly] = useState();
  const [hasHistoryYearly, setHistoryYearly] = useState();
  const [displayState, setDisplayState] = useState('latest'); // latest, history
  const [paramSelect, setParamSelect] = useState('ฝนรายวัน');
  const [dataParam] = useState(['ฝนรายวัน', 'ฝนรายเดือน', 'ฝนรายปี']);
  const { currentMode, currentArea } = useContext(ModeContext);
  const useStyles = makeStyles(styles);
  const useStyleGlobal = makeStyles(globalStyle);
  const classes = useStyles();
  const classe = useStyleGlobal();
  const { t } = useTranslation();
  const initPath = `/${process.env.REACT_APP_PATH}`;
  const apiDailyLatest = 'https://api.hii.or.th/v2/MBtOTp6IUXbjaCxhQoFQNrFgZUCzNgbo/isohyet/daily/latest/';
  const apiDailyHistory = 'https://api.hii.or.th/v2/MBtOTp6IUXbjaCxhQoFQNrFgZUCzNgbo/isohyet/daily/history/';
  const apiMonthlyHistory = 'https://api.hii.or.th/v2/MBtOTp6IUXbjaCxhQoFQNrFgZUCzNgbo/isohyet/monthly/';
  const apiYearlyHistory = 'https://api.hii.or.th/v2/MBtOTp6IUXbjaCxhQoFQNrFgZUCzNgbo/isohyet/yearly/';
  const placeHolder = 'https://via.placeholder.com/201x269?text=No%20Image&italic=true';
  const width = '90%';
  const matches = useMediaQuery('(max-width:768px)');
  let widthModal = '90%';
  if (!matches) {
    widthModal = '50%';
  }
  const [modalData, setModalData] = useState({
    open: false,
    header: 'ภาพ',
    subheader: null,
    content: null,
  });
  const [modalDataReset] = useState({
    open: false,
    header: '',
    subheader: null,
    content: null,
  });
  const handleDateChange = (date) => {
    if (paramSelect === 'ฝนรายวัน') {
      setCurrentDate(moment(date).format('yyyy-MM-DD'));
    } else {
      setCurrentDate(moment(date).format('YYYY'));
    }
  };

  const handleImage = (data) => (e) => {
    e.preventDefault();
    if (data.mode === 'daily') {
      setModalData({
        open: true,
        header: `ภาพ${data.title}`,
        content: (
          <Box py={2} display="flex" alignItems="center" justify="center">
            <Img
              src={data.url}
              alt={data.time}
              width={widthModal}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Box>
        ),
      });
    }
    if (data.mode === 'monthly') {
      setModalData({
        open: true,
        header: `เดือน ${data.title}`,
        content: (
          <Box py={2} display="flex" alignItems="center" justify="center">
            <Img
              src={data.url}
              // alt={data.time}
              width={widthModal}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Box>
        ),
      });
    }
    if (data.mode === 'yearly') {
      setModalData({
        open: true,
        header: `ปี ${data.title}`,
        content: (
          <Box py={2} display="flex" alignItems="center" justify="center">
            <Img
              src={data.url}
              // alt={data.time}
              width={widthModal}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Box>
        ),
      });
    }
  };

  const handleParamChange = (event) => {
    setParamSelect(event.target.value);
    setTimeout(() => {
      if (event.target.value === 'ฝนรายวัน') {
        setCurrentDate(moment(maxDateTime).format('yyyy-MM-DD'));
      } else {
        setCurrentDate(moment(maxDateTime).format('YYYY'));
      }
    }, 500);
  };

  function resetModal() {
    setModalData(modalDataReset);
    modalData.open = false;
  }

  function renderimage(value) {
    let realImage1day = '';
    let realImage3day = '';
    let realImage7day = '';
    let realImage15day = '';
    let realImage30day = '';
    let images = null;
    let geotiffs = null;
    let asciis = null;
    value.map((row) => {
      images = row.image;
      geotiffs = row.geotiff;
      asciis = row.ascii;
      if (images && geotiffs && asciis) {
        realImage1day = (
          <Button
            id="btn_isohyet_1d"
            onClick={handleImage({
              url: images.rain_1d, title: t('ฝนสะสม 1 วัน'), time: moment(images.latest_date).format('ll'), mode: 'daily',
            })}
          >
            <Img
              id="img_isohyet_1d"
              src={`${images.rain_1d_thumb}`}
              width={width}
              alt={moment(images.latest_date).format('ll')}
              className={classes.responsive}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Button>
        );
        realImage3day = (
          <Button
            id="btn_isohyet_3d"
            onClick={handleImage({
              url: images.rain_3d, title: t('ฝนสะสม 3 วัน'), time: moment(images.latest_date).format('ll'), mode: 'daily',
            })}
          >
            <Img
              id="img_isohyet_3d"
              src={`${images.rain_3d_thumb}`}
              width={width}
              alt={moment(images.latest_date).format('ll')}
              className={classes.responsive}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Button>
        );
        realImage7day = (
          <Button
            id="btn_isohyet_7d"
            onClick={handleImage({
              url: images.rain_7d, title: t('ฝนสะสม 7 วัน'), time: moment(images.latest_date).format('ll'), mode: 'daily',
            })}
          >
            <Img
              id="img_isohyet_7d"
              src={`${images.rain_7d_thumb}`}
              width={width}
              alt={moment(images.latest_date).format('ll')}
              className={classes.responsive}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Button>
        );
        realImage15day = (
          <Button
            id="btn_isohyet_15d"
            onClick={handleImage({
              url: images.rain_15d, title: t('ฝนสะสม 15 วัน'), time: moment(images.latest_date).format('ll'), mode: 'daily',
            })}
          >
            <Img
              id="img_isohyet_15d"
              src={`${images.rain_15d_thumb}`}
              width={width}
              alt={moment(images.latest_date).format('ll')}
              className={classes.responsive}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Button>
        );
        realImage30day = (
          <Button
            id="btn_isohyet_30d"
            onClick={handleImage({
              url: images.rain_30d, title: t('ฝนสะสม 30 วัน'), time: moment(images.latest_date).format('ll'), mode: 'daily',
            })}
          >
            <Img
              id="img_isohyet_30d"
              src={`${images.rain_30d_thumb}`}
              width={width}
              alt={moment(images.latest_date).format('ll')}
              className={classes.responsive}
              unloader={(
                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
              )}
            />
          </Button>
        );
      }
      return false;
    });
    return (
      <>
        <Grid item xs={6} sm={4} md={4}>
          <Box display="block" mt={2}>
            <Box className={classes.titleBox}>
              <Grid container>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-start' }} width="100%">
                    <Box px={2} id="isohyet_1d">{t('ฝนสะสม 1 วัน')}</Box>
                  </Box>
                </Grid>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-end' }} justifyItems="center" width="100%">
                    <Box display="flex">
                      <FlexButton id="isohyet_1d_ascii" target="_blank" href={asciis.rain_1d}>ASCII</FlexButton>
                      <FlexButton id="isohyet_1d_geotiff" style={{ marginLeft: 10, textTransform: 'none' }} target="_blank" href={geotiffs.rain_1d}>GeoTIFF</FlexButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.bodyBox} alignItems="center">
              {realImage1day}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} sm={4} md={4}>
          <Box display="block" mt={2}>
            <Box className={classes.titleBox}>
              <Grid container>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-start' }} width="100%">
                    <Box px={2}>{t('ฝนสะสม 3 วัน')}</Box>
                  </Box>
                </Grid>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-end' }} justifyItems="center" width="100%">
                    <Box>
                      <FlexButton target="_blank" href={asciis.rain_3d}>ASCII</FlexButton>
                      <FlexButton style={{ marginLeft: 10, textTransform: 'none' }} target="_blank" href={geotiffs.rain_3d}>GeoTIFF</FlexButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.bodyBox} alignItems="center">
              {realImage3day}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} sm={4} md={4}>
          <Box display="block" mt={2}>
            <Box className={classes.titleBox}>
              <Grid container>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-start' }} width="100%">
                    <Box px={2}>{t('ฝนสะสม 7 วัน')}</Box>
                  </Box>
                </Grid>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-end' }} justifyItems="center" width="100%">
                    <Box>
                      <FlexButton target="_blank" href={asciis.rain_7d}>ASCII</FlexButton>
                      <FlexButton style={{ marginLeft: 10, textTransform: 'none' }} target="_blank" href={geotiffs.rain_7d}>GeoTIFF</FlexButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.bodyBox} alignItems="center">
              {realImage7day}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} sm={4} md={4}>
          <Box display="block" mt={2}>
            <Box className={classes.titleBox}>
              <Grid container>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-start' }} width="100%">
                    <Box px={2}>{t('ฝนสะสม 15 วัน')}</Box>
                  </Box>
                </Grid>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-end' }} justifyItems="center" width="100%">
                    <Box>
                      <FlexButton target="_blank" href={asciis.rain_15d}>ASCII</FlexButton>
                      <FlexButton style={{ marginLeft: 10, textTransform: 'none' }} target="_blank" href={geotiffs.rain_15d}>GeoTIFF</FlexButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.bodyBox} alignItems="center">
              {realImage15day}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} sm={4} md={4}>
          <Box display="block" mt={2}>
            <Box className={classes.titleBox}>
              <Grid container>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-start' }} width="100%">
                    <Box px={2}>{t('ฝนสะสม 30 วัน')}</Box>
                  </Box>
                </Grid>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-end' }} justifyItems="center" width="100%">
                    <Box>
                      <FlexButton target="_blank" href={asciis.rain_30d}>ASCII</FlexButton>
                      <FlexButton style={{ marginLeft: 10, textTransform: 'none' }} target="_blank" href={geotiffs.rain_30d}>GeoTIFF</FlexButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.bodyBox} alignItems="center">
              {realImage30day}
            </Box>
          </Box>
        </Grid>
        {/* <Modal
          open={modalData.open}
          modalHeader={modalData.header}
          modalSubHeader={modalData.subheader}
          modalContent={modalData.content}
          resetModal={resetModal}
        /> */}
      </>
    );
  }

  function groupDataMonthly(value) {
    const valueImage = value.map((rows) => {
      const keys = Object.keys(rows);
      const dataInMonth = keys.map((month) => {
        const objData = rows[month];
        switch (month) {
          case 'm01':
            objData.month = 'มกราคม';
            break;
          case 'm02':
            objData.month = 'กุมภาพันธ์';
            break;
          case 'm03':
            objData.month = 'มีนาคม';
            break;
          case 'm04':
            objData.month = 'เมษายน';
            break;
          case 'm05':
            objData.month = 'พฤษภาคม';
            break;
          case 'm06':
            objData.month = 'มิถุนายน';
            break;
          case 'm07':
            objData.month = 'กรกฎาคม';
            break;
          case 'm08':
            objData.month = 'สิงหาคม';
            break;
          case 'm09':
            objData.month = 'กันยายน';
            break;
          case 'm10':
            objData.month = 'ตุลาคม';
            break;
          case 'm11':
            objData.month = 'พฤศจิกายน';
            break;
          case 'm12':
            objData.month = 'ธันวาคม';
            break;
          default:
            objData.month = `เดือน ${month}`;
            break;
        }
        return objData;
      });
      return dataInMonth;
    });
    return valueImage;
  }

  function renderimageMonthly(value) {
    const valueImage = groupDataMonthly(value)[0];
    return valueImage.map((rows, i) => (
      <React.Fragment key={uniqueId()}>
        <Grid item xs={6} sm={4} md={3}>
          <Box display="block" mt={2}>
            <Box className={classes.titleBox}>
              <Grid container>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-start' }} width="100%">
                    <Box px={2}>{rows.month}</Box>
                  </Box>
                </Grid>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-end' }} justifyItems="center" width="100%">
                    <Box display="flex">
                      <FlexButton id={`isohyet_m${i + 1}_ascii`} target="_blank" href={rows.ascii} download>ASCII</FlexButton>
                      <FlexButton id={`isohyet_m${i + 1}_geotiff`} style={{ marginLeft: 10, textTransform: 'none' }} target="_blank" href={rows.geotiff} download>GeoTIFF</FlexButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.bodyBox} alignItems="center">
              <Button id={`btn_isohyet_m${i + 1}`} onClick={handleImage({ url: rows.img, title: rows.month, mode: 'monthly' })}>
                <Img
                  src={`${rows.tn_img}`}
                  width={width}
                  className={classes.responsive}
                  unloader={(
                    <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                  )}
                />
              </Button>
            </Box>
          </Box>
        </Grid>
      </React.Fragment>
    ));
  }

  function groupData(value) {
    const valueImage = value.map((rows) => {
      const keys = Object.keys(rows);
      const dataInYear = keys.map((years) => {
        const objData = rows[years];
        objData.year = years;
        return rows[years];
      });
      return dataInYear;
    });
    return valueImage;
  }

  function renderimageYearly(value) {
    const valueImage = groupData(value)[0];
    return valueImage.map((rows) => (
      <React.Fragment key={uniqueId()}>
        <Grid item xs={6} sm={4} md={3}>
          <Box display="block" mt={2}>
            <Box className={classes.titleBox}>
              <Grid container>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-start' }} width="100%">
                    <Box px={2}>{rows.year}</Box>
                  </Box>
                </Grid>
                <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Box display="flex" justify={{ sm: 'center', md: 'flex-end' }} justifyItems="center" width="100%">
                    <Box display="flex">
                      <FlexButton id={`isohyet_y${rows.year}_ascii`} target="_blank" href={rows.ascii} download>ASCII</FlexButton>
                      <FlexButton id={`isohyet_y${rows.year}_geotiff`} style={{ marginLeft: 10, textTransform: 'none' }} target="_blank" href={rows.geotiff} download>GeoTIFF</FlexButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.bodyBox} alignItems="center">
              <Button id={`btn_isohyet_y${rows.year}`} onClick={handleImage({ url: rows.img, title: rows.year, mode: 'yearly' })}>
                <Img
                  id={`img_isohyet_y${rows.year}`}
                  src={`${rows.tn_img}`}
                  width={width}
                  className={classes.responsive}
                  alt={`Year ${rows.year}`}
                  unloader={(
                    <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                  )}
                />
              </Button>
            </Box>
          </Box>
        </Grid>
      </React.Fragment>
    ));
  }

  // fetch data lasted
  useEffect(() => {
    function fetchData() {
      fetch(`${apiDailyLatest}${currentMode === 'province' ? 'thailand' : currentMode}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          setLatest([result]);
          setMaxDateTime(result.image.latest_date);
          setCurrentDate(result.image.latest_date);
          sethasError(false);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    function fetchDataLastedArea() {
      fetch(`${apiDailyLatest}${currentMode}/${currentArea.code}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          if (result) {
            setLatest([result]);
            setCurrentDate(result.image.latest_date);
            setMaxDateTime(result.image.latest_date);
            sethasError(false);
          }
        })
        .finally(() => {
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    if (currentMode && (currentArea.code === '0') && (displayState === 'latest')) {
      fetchData();
    } else if (currentMode && (currentArea.code !== '0') && (displayState === 'latest')) {
      fetchDataLastedArea();
    }
  }, [currentArea, currentArea.code, currentDate, currentMode, displayState]);

  // fetch data history
  useEffect(() => {
    function fetchDataDaily() {
      let apiFetch = '';
      if (currentMode === 'province') {
        apiFetch = `${apiDailyHistory}${currentDate}/${currentArea.code === '0' ? 'thailand' : `province/${currentArea.code}`}`;
      } else {
        apiFetch = `${apiDailyHistory}${currentDate}/${currentArea.code === '0' ? 'thailand_basin' : `basin/${currentArea.code}`}`;
      }
      fetch(apiFetch)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          if (result) {
            setHistory([result]);
            sethasError(false);
          }
        })
        .finally(() => {
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    function fetchDataMonthly() {
      let apiFetch = '';
      if (currentMode === 'province') {
        apiFetch = `${apiMonthlyHistory}${moment(currentDate).format('YYYY')}/${currentArea.code === '0' ? 'thailand' : `province/${currentArea.code}`}`;
      } else {
        apiFetch = `${apiMonthlyHistory}${moment(currentDate).format('YYYY')}/${currentArea.code === '0' ? 'thailand_basin' : `basin/${currentArea.code}`}`;
      }
      fetch(apiFetch)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          if (result) {
            setHistoryMonthly([result]);
            sethasError(false);
          }
        })
        .finally(() => {
          setLoading(false);
        })
        .catch(() => {
          sethasError(true);
        });
    }
    function fetchDataYearly() {
      let apiFetch = '';
      if (currentMode === 'province') {
        apiFetch = `${apiYearlyHistory}${currentArea.code === '0' ? 'thailand' : `province/${currentArea.code}`}`;
      } else {
        apiFetch = `${apiYearlyHistory}${currentArea.code === '0' ? 'thailand_basin/00' : `basin/${currentArea.code}`}`;
      }
      fetch(apiFetch)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          if (result) {
            setHistoryYearly([result]);
          }
        })
        .finally(() => {
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }

    if (currentMode && (displayState === 'history') && (paramSelect === 'ฝนรายวัน')) {
      fetchDataDaily();
    }
    if (currentMode && (displayState === 'history') && (paramSelect === 'ฝนรายเดือน')) {
      fetchDataMonthly();
    }
    if (currentMode && (displayState === 'history') && (paramSelect === 'ฝนรายปี')) {
      fetchDataYearly();
    }
  }, [currentArea.code, currentDate, currentMode, displayState, paramSelect]);

  return (
    <React.Fragment key={uniqueId()}>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}
      <Box display="flex" alignItems="center">
        <Grid container direction="row" alignItems="center">
          <Grid item xs={12} sm="auto">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classe.shapeCircle} alignItems="center" justifyContent="center">
                <RainIcon style={{ color: 'white' }} />
              </Box>
              <Box p={1}><Typography variant="h6" className={classe.titlePage}>{t('ฝน')}</Typography></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm>
            <Grid container direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
              <Grid item>
                <FormControl className={classes.formControl}>
                  <StyledViewButton id="rain-menu-btn" onClick={() => window.location.assign(`${initPath}rainfall?typeAll=0`)} variant="outlined" size="small">
                    {t('ฝนสะสม')}
                  </StyledViewButton>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl className={classes.formControl}>
                  <StyledViewButton id="rain-stat-menu-btn" onClick={() => window.location.assign(`${initPath}rainfall?typeAll=1`)} variant="outlined" size="small">
                    {t('ฝนสถิติ')}
                  </StyledViewButton>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl className={classes.formControl}>
                  <StyledViewButton id="rain-stat-menu-btn" onClick={() => window.location.assign(`${initPath}rainfall/isohyet`)} variant="outlined" size="small" className={classe.active_btnStyle}>
                    {t('ภาพ isohyet')}
                  </StyledViewButton>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={0} className={classes.boxTopRadius} style={{ marginTop: 24 }}>
        <Grid item xs={12} md={7}>
          <Box m={1} className={classes.titleName}>
            {t('ภาพ isohyet')}
          </Box>
        </Grid>
        <Grid item xs>
          <Tooltip title={t('ดูภาพล่าสุด')}>
            <Button
              className={classes.outlinedLeftPrimary}
              color={displayState === 'latest' ? 'primary' : 'default'}
              variant={displayState === 'latest' ? 'contained' : 'text'}
              onClick={() => setDisplayState('latest')}
            >
              <ImageOutlinedIcon fontSize="small" />
              <Hidden xsDown>
                <Typography variant="h6" style={{ marginLeft: 8 }}>
                  {t('ดูภาพล่าสุด')}
                </Typography>
              </Hidden>
            </Button>
          </Tooltip>
        </Grid>
        <Grid item xs>
          <Tooltip title={t('ดูภาพย้อนหลัง')}>
            <Button
              id="isohyet-history"
              className={classes.outlinedPrimary}
              color={displayState === 'history' ? 'primary' : 'default'}
              variant={displayState === 'history' ? 'contained' : 'text'}
              onClick={() => setDisplayState('history')}
            >
              <PhotoLibraryOutlinedIcon fontSize="small" />
              <Hidden xsDown>
                <Typography variant="h6" style={{ marginLeft: 8 }}>
                  {t('ดูภาพย้อนหลัง')}
                </Typography>
              </Hidden>
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
      {displayState === 'latest' && (
        <>
          {hasLatest && (
            <Grid container spacing={3} style={{ paddingTop: 20 }} justifyContent="flex-start">
              {renderimage(hasLatest)}
            </Grid>
          )}
        </>
      )}
      {displayState === 'history' && (
        <>
          {/* dropdown zone */}
          <Box mt={2} />
          <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="center">
            <Grid item xs={12} sm="auto">
              <Box>
                ประเภทข้อมูล
              </Box>
            </Grid>
            <Grid item xs="auto">
              <Box>
                <Select
                  value={paramSelect}
                  onChange={handleParamChange}
                  id="isohyet-type"
                  style={{ marginLeft: '3%' }}
                >
                  {dataParam.map((row) => (
                    <MenuItem key={row} value={row}>
                      {t(row)}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Grid>
            <Grid item>
              <Box>
                {paramSelect === 'ฝนรายวัน' && (
                  <Box>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        value={currentDate}
                        format="DD/MM/yyyy"
                        onChange={handleDateChange}
                        style={{ fontSize: 14, maxWidth: 150 }}
                        maxDate={maxDateTime}
                        KeyboardButtonProps={{
                          'data-cy': 'change date',
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>
                )}
                {paramSelect === 'ฝนรายเดือน' && (
                  <Box>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        id="selected-year"
                        views={['year']}
                        value={currentDate}
                        format="YYYY"
                        minDate={new Date('2012')}
                        onChange={handleDateChange}
                        style={{ fontSize: 14, maxWidth: 150 }}
                        maxDate={maxDateTime}
                        KeyboardButtonProps={{
                          'data-cy': 'change year',
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
          {hasHistory && (
            <Grid container spacing={3} style={{ paddingTop: 20 }} justifyContent="flex-start">
              {paramSelect === 'ฝนรายวัน' && (
                renderimage(hasHistory)
              )}
            </Grid>
          )}
          {hasHistoryMonthly && (
            <Grid container spacing={3} style={{ paddingTop: 20 }} justifyContent="flex-start">
              {paramSelect === 'ฝนรายเดือน' && (
                renderimageMonthly(hasHistoryMonthly)
              )}
            </Grid>
          )}
          {hasHistoryYearly && (
            <Grid container spacing={3} style={{ paddingTop: 20 }} justifyContent="flex-start">
              {paramSelect === 'ฝนรายปี' && (
                renderimageYearly(hasHistoryYearly)
              )}
            </Grid>
          )}
        </>
      )}
      <Modal
        open={modalData.open}
        modalHeader={modalData.header}
        modalSubHeader={modalData.subheader}
        modalContent={modalData.content}
        resetModal={resetModal}
      />
    </React.Fragment>
  );
}
